import axiosInstance from '../utils/axiosInstance';

export const loginSuperAdmin = async (credentials) => {
  const response = await axiosInstance.post('/auth/superadmin/login', credentials);
  return response.data;
};

export const loginAdmin = async (credentials) => {
  const response = await axiosInstance.post('/auth/admin/login', credentials);
  return response.data;
};